/* eslint-disable no-return-assign */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../actions';
import * as c from '../constant';

function ViewAnnualSOA({ data, getReportAccess }) {
  const [iframeKey, setIframeKey] = useState(1);
  const authProfile = getJson('profile') || {};
  const [src, setSrc] = useState('');

  useEffect(() => {
    const args = {
      path: c.BPLS_E2E_ANNUAL_ESOA_URL.replace('{id}', _.get(data, 'id')),
      email: _.get(authProfile, 'email'),
      output: 'I',
    };
    getReportAccess(args, (response) => {
      setSrc(response?.res?.res?.url || '');
    });
  }, []);

  useEffect(() => {
    setIframeKey(_.random(1, 1000));
  }, []);

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  key={iframeKey}
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="Annual Statement of Account"
                  src={src || ''}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewAnnualSOA.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => {
  return {
    item: get(api, `${c.ITEM}.item`) || {},
  };
};

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewAnnualSOA);
